<template>
    <div class="login-box">
        <div class="login-logo">
            <b>PAM</b> Rapprochement
        </div>
        <!-- /.login-logo -->
        <div class="login-box-body">
            <p class="login-box-msg">Sign in to start your session</p>

            <form action="../../index2.html" method="post">
                <div class="form-group has-feedback">
                    <input type="email" class="form-control" placeholder="Login" v-model="username">
                    <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
                </div>
                <!--<div class="form-group has-feedback">-->
                    <!--<input type="password" class="form-control" placeholder="Password" v-model="pwd">-->
                    <!--<span class="glyphicon glyphicon-lock form-control-feedback"></span>-->
                <!--</div>-->
                <div class="row">
                    <!-- /.col -->
                    <div class="col-xs-4">
                        <button type="submit"
                                @click.prevent="login()"
                                :disabled="btnIsDisabled"
                                class="btn btn-primary btn-block btn-flat"
                        >Sign In
                        </button>
                    </div>
                    <!-- /.col -->
                </div>
            </form>
        </div>
        <!-- /.login-box-body -->
    </div>
</template>

<script>
    import api from '../../resources/apiProvider'
    import 'admin-lte/dist/js/adminlte'
    import Vue from 'vue'
    import localStorage from 'localStorage'

    export default {
        mounted() {
            $('body').removeClass().addClass('login-page')
        },
        data () {
            return {
                username: 'laurent.baltimore',
                pwd: 'motdepasse'
            }
        },
        methods: {
            login() {
                let idUser = this.username
                let result = Vue.http.get(
                    api.getResourceUri().auth.auth,
                    {
                        params: {username:idUser, password:'123'},
                        headers: {'Authorization': 'Basic ' + idUser }
                    })

                result.then(res => {
                    this.$store.storeAuth.dispatch("setConnected", true)
                    this.$store.storeAuth.dispatch("setUser", res.data.user)
                    this.$store.storeAuth.dispatch("setToken", res.data.token)
                    localStorage.setItem('token', res.data.token)
                    $('body').removeClass().addClass('skin-purple sidebar-mini')
                    location.reload()
                })
            }

        },
        computed: {
            btnIsDisabled() {
                return this.username === '' || this.pwd === ''
            }
        }
    }
</script>